/* eslint-disable */
import RuleConfig from './reducer';
import operation from './operation';

export default RuleConfig;
export { operation };
